"use strict"

class Mentions {
    constructor() {
      this.mentions = document.querySelector("#mentionslegales")
      this.header = document.querySelector("#header");
    }

    init(){
        if(this.mentions){
          this.header.classList.add("noSticky");
        }
    }
}

export default Mentions


// WEBPACK FOOTER //
// ./src/scripts/components/Mentions.js